/**
 * DESIGN: 赤钢工业线 — structured data mirrors only on-page, verified-neutral content and never invents offers, ratings or certifications.
 * BreadcrumbList is emitted once from the SSR route registry and synchronised in PageMeta on client navigation.
 */
export default function JsonLd({ data }: { data: Record<string, unknown> }) {
  if (data["@type"] === "BreadcrumbList") return null;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}
